import React, { useEffect, useState, useCallback } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, Typography, DialogContent, DialogTitle, DialogActions, styled } from "@mui/material";
import Welcome from "../components/patient/Welcome";
import theme from "src/config/theme";
import { ReactComponent as Profile } from '../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../assets/images/arrow-right 2.svg';
import { ReactComponent as SliderVertical } from '../../../assets/images/slider-vertical.svg';
import { ReactComponent as Edit2 } from '../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../assets/images/close-circle.svg';
import { ReactComponent as Add } from '../../../assets/images/add-square.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import { ReactComponent as Danger } from '../../../assets/images/danger.svg';
import CustomCard from "src/modules/app/components/CustomCard/AppointmentCard";
import { useNavigate, useParams } from 'react-router-dom';
import NoDataFound from "../components/NoDataFound/NoDataFound";
import { useDispatch, useSelector } from 'react-redux';
import { getStaffRequest } from '../../../modules/app/store/appActions';
import storage from "src/utils/storageUtils";
import RightSidebar from "../../../components/App/RIghtSidebar/RightSidebar";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import ButtonComponent from "src/components/shared/Button";
import AddStaff from "../components/LefSidebarForms/AddStaff/AddStaff";
import StaffCard from "../components/CustomCard/StaffCard";
import useResponsive from "src/components/hooks/useResponsive";
export const AvatarIcon = styled(Avatar)({
  width: '64px',
  height: '64px',
  padding: '10px',
  borderRadius: '40px',
  background: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18)), #FFFFFF',
  marginBottom: '5px'
})


const columns = [
  { id: "staff", label: "Staff Name", sx: { "& .css-s1474d": { justifyContent: 'flex-Start !important' } }, },

  { id: "role", label: "Role", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },

];

const StaffContainer = () => {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const { clinicId: routeClinicId } = useParams();
  const [isCardView, setIsCardView] = useState(false);
  const [open, setOpen] = useState(false);
  const [staff, setStaff] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const clinic = useSelector((state) => state.app.clinics);
  const clinicId = routeClinicId || clinic?.currentClinic?.id || storage.get('CLINIC_ID') || storage.get('CLINICID');




  const fetchStaff = useCallback(
    (page = 0, perPage = 10) => {
      const token = storage.get('TOKEN');
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const params = {
            page: page + 1,
            limit: perPage,
            clinicId: clinicId,
          };
          const response = await new Promise((resolve, reject) =>
            dispatch(getStaffRequest({ token, params }, resolve, reject)),
          );
          if (response?.data && response?.meta) {
            setStaff(response.data);
            setTotalCount(response.meta.totalRecords);
          }
        } catch (error) {
          console.error("Staff fetch error:", error);
          setStaff([]);
          setTotalCount(0);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    },
    [dispatch, clinicId],
  );


  useEffect(() => {
    if (clinicId) {
      fetchStaff(page, perPage);
    }
  }, [fetchStaff, page, perPage, clinicId]);


  const handleSearch = useCallback((value) => {
    const token = storage.get('TOKEN');
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const params = {
          clinicId: clinicId,
          ...(value ? { search: value } : {})
        };
        const response = await new Promise((resolve, reject) =>
          dispatch(getStaffRequest({ token, params }, resolve, reject))
        );
        if (response) {
          setStaff(response.data);
        }
      } catch (error) {
        console.error("Staff handleSearch error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch, clinicId]);


  const data = staff.map((staffData) => ({
    staffId: staffData.id,
    avatarInitial: staffData?.name?.charAt(0)?.toUpperCase() || 'N',
    name: staffData?.name,
    staff: (
      <Box sx={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: "8px" }}>
        <Avatar sx={{ background: theme.palette.primary.light4, color: theme.palette.primary.main }}>{staffData?.name?.charAt(0)?.toUpperCase() || 'N'}</Avatar>
        <span>{staffData?.name || "N/A"}</span>
      </Box>
    ),
    email: staffData?.email ? `${staffData.email}` : "N/A",
    role: staffData?.role ? `${staffData.role} ` : 'N/A',

  }))

  const actions = [


    {
      label: "Cancel", icon: <Close width={isMobile || isTablet ? 18 : 24}
        height={isMobile || isTablet ? 18 : 24} />, onClick: (row) => alert(`Editing `)
    }
  ];
  return (
    <>
      <Welcome category="staff" setIsCardView={setIsCardView} isCardView={isCardView} updateStaff={fetchStaff} handleSearch={handleSearch} />
      <Box sx={{ mb: 16 }} />

      <Box sx={{
        height: 'calc(100vh - 240px)',
        margin: 2,
        boxShadow: isMobile || isTablet || isCardView || isCardView ? 'none' : theme.shadows[1],
        borderRadius: '10px',
        border: isMobile || isTablet || isCardView || isCardView ? 'none' : `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
        backgroundColor: isMobile || isTablet || isCardView ? 'none' : theme.palette.gery.white,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: (isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'space-between',
        alignItems: (isMobile || isTablet || isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'none',
        position: 'relative',
        maxHeight: 'calc(100vh - 240px)'
      }}>

        {(isMobile || isTablet || isCardView) ? (
          data.length === 0 ? (
            <NoDataFound
              title="No Staff Found!"
              buttonText="Add Staff"
              buttonIcon={Add}
              // onClick={handleOpen}
              disabled={true}
              showButton={false}
            />
          ) : (
            <StaffCard
              data={data}
              page={page}
              perPage={perPage}
              setPage={setPage}
              totalCount={totalCount}
            />
          )
        ) : (
          <CustomTable
            disabled={true}
            columns={columns}
            data={data}
            actions={actions}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            loading={isLoading}
            noDataComponent={
              isLoading ? <></> : (
                <NoDataFound
                  title="No Staff Found!"
                  buttonText="Add Staff"
                  buttonIcon={Add}
                  onClick={handleOpen}
                  disabled={true}
                  showButton={false}
                />
              )
            }
          />
        )}

      </Box>



      <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

    </>
  )
};

export default StaffContainer;